<template>
	<div>
		<triangle-image
			title="Le tue statistiche su Quomi"
			subtitle='Ecco alcune informazioni sui dati che puoi visualizzare sulla sezione principale del tuo "My Quomi"'>
		</triangle-image>

		<div class="container">
			<div class="content">
				<section class="paragraph">
					<h2>
						Tipologie di ricette
					</h2>

					<p>
						Nel grafico a torta saranno riportate le quantità in percentuale delle tipologie di ricette che hai ordinato su Quomi. Le categorie indicate sono: <b>pesce, carne bianca, carne rossa, vegetariana, vegana</b>. Tieni presente che ogni tipologia può includere, ad esempio, primi piatti di pasta o riso, o secondi piatti con o senza contorni.
						<br>
						In Quomi cerchiamo di ispirarci ai principi della <b>dieta mediterranea</b>, la più equilibrata e varia. Per questo proponiamo ogni settimana dei menù che includono un piatto di carne rossa, uno di carne bianca, uno di pesce e altri vegetariani basati su legumi o carboidrati.

						<router-link
		                    :to="{ name: 'how-we-create' }"
		                    class="flex flex-center"
		                >
		                    <CTA
		                        :content="`Scopri come creiamo le ricette`"
		                    />
		                </router-link>
					</p>

					<h2>
						Numero di cene risolte
					</h2>

					<p>
						Questo numero rappresenta le <b>porzioni per singola persona</b> che hai cucinato con le ricette di Quomi. La nostra missione è quella di accompagnarti sempre con gusto nella <b>soluzione del problema</b> “Cosa faccio da mangiare stasera?”. Ogni volta che questa numero crescerà, sapremo di aver contribuito a darti <b>una mano concreta nel cucinare piatti sani e nuovi</b>, per uno stile di vita più vario ed equilibrato.
					</p>

					<h2>
						Emissioni di CO2 risparmiate
					</h2>

					<p>Un dato del quale andare fieri! In base ad <a href="https://news.umich.edu/those-home-delivered-meal-kits-are-greener-than-you-thought-new-study-concludes/" class="link-detail" target="_blank">uno studio</a> effettuato dall’Università del Michigan, è stato calcolato che per ogni pasto realizzato grazie ad un servizio di meal kit vengono risparmiati in media 2 kg di emissioni di CO2 <b>rispetto allo stesso pasto preparato con una spesa effettuata al supermercato</b>. Ad impattare sono in particolare: la <b>riduzione dello spreco di cibo</b> (0,9 kg per pasto), <b>una filiera più corta</b> (1,05 kg per pasto) e minori emissioni nella <b>consegna dell’ultimo miglio</b> (0,45 kg per pasto).
					</p>

					<router-link
	                    :to="{ name: 'dashboard' }"
	                    class="flex flex-center"
	                >
	                    <CTA
	                        :content="`Torna su My Quomi`"
	                    />
	                </router-link>
				</section>	
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import TriangleImage from '../TriangleImage'

	export default {
	components: {
		'triangle-image': TriangleImage,
	}

}
</script>

<style scoped>

.triangle-image {
		background: url("../../assets/img/covers/eco.jpg");
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
	}


.content {
	max-width: 800px;
}

.paragraph p {
  margin-bottom: 45px;
}

.logos {
	margin: 20px 0;
}

</style>
